import { get, set, uniq } from 'global/lib/lodash';
import { buildFilters } from 'global/utils/filter';
import { DateRanges } from '../../lib/filter';

export const cleanChartFilters = (filter) => {
  const filters = buildFilters(filter, {
    dontFilter: ['ownership', 'quality_type', 'user_id'],
    dontSort: true,
    overrideFilter: (f) => {
      if (f.realms) {
        f.realm_id = uniq([f.realm_id, ...f.realms.split(',')].filter((f) => !!f)).join(',');
      }

      return {
        ...f,
        _showCompare: filter._showCompare,
        realms: undefined,
      };
    },
  });

  if (get(filters, 'filter.scorecard_id') === 0) {
    set(filters, 'filter.scorecard_id', undefined);
  }

  if (get(filters, 'filter.superset_id') === 0) {
    set(filters, 'filter.superset_id', undefined);
  }

  if (!['all', 'none'].includes(get(filter, 'daterange'))) {
    const fdr = DateRanges.find((dr) => dr.value == filter.daterange);
    set(filters, 'filter.start_date', get(fdr, 'vals.0'));
    set(filters, 'filter.end_date', get(fdr, 'vals.1'));
  }

  set(filters, 'filter._daterange', filter.daterange);

  return filters;
};
